import DirectoryModel from "src/app/model/api/directory/directoryModel";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class DirectoriesTable extends DatabaseTable<DirectoryModel> {

  public async getAll(): Promise<DirectoryModel[]> {
    return await this.GetAllRecords()
  }

  public async getById(Id: number): Promise<DirectoryModel> {
    let records = await this.GetRecordsById(0, 1, Id, Id)
    if (records.length) {
      return records[0]
    }
    return null
  }

  public async getByPurpose(purpose: string): Promise<DirectoryModel> {
    let records = await this.GetRecordsByIndex(0, 1, 'Purpose', purpose, purpose)
    if (records.length) {
      return records[0]
    }
    return null
  }

  public async update(record: DirectoryModel): Promise<number> {
    return await this.UpdateRecord(record)
  }

  public async delete(record: DirectoryModel): Promise<void> {
    if (!record?.Id) return
    await this.DeleteRecord(record.Id)
  }

}